import { fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { SensorStreamWatchdogSettingsFormViewModel } from "../types";

export default function SensorStreamWatchdogSettingsFormApp(props: SensorStreamWatchdogSettingsFormViewModel) {
  const [cronExpression, setCronExpression] = useState(props.values.cronExpression);
  const [emails, setEmails] = useState(props.values.emails);
  const [threshold, setThreshold] = useState(String(props.values.threshold));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting || !props.canEdit) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("CronExpression", cronExpression);
      formData.append("Emails", emails);
      formData.append("Threshold", threshold);
      formData.append("saveAndClose", "false");

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      window.location.reload();
    } catch (error) {
      setErrorMessage(error instanceof Error ? error.message : "Ulozeni se nepodarilo.");
    } finally {
      setIsSubmitting(false);
    }
  }

  const disabled = !props.canEdit || isSubmitting;

  return (
    <div className="forms-app sensor-stream-watchdog-settings-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="base-form">
        <div className="form-group">
          <div className="row">
            <div className="col-sm-9">
              <label htmlFor="sensor-stream-watchdog-cron">{props.labels.cronExpression}</label>
              <input
                id="sensor-stream-watchdog-cron"
                className="form-control"
                value={cronExpression}
                disabled={disabled}
                onChange={(event) => {
                  setCronExpression(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-sm-9">
              <label htmlFor="sensor-stream-watchdog-emails">{props.labels.emails}</label>
              <input
                id="sensor-stream-watchdog-emails"
                className="form-control"
                value={emails}
                disabled={disabled}
                onChange={(event) => {
                  setEmails(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-sm-9">
              <label htmlFor="sensor-stream-watchdog-threshold">{props.labels.threshold}</label>
              <input
                id="sensor-stream-watchdog-threshold"
                className="form-control"
                type="number"
                value={threshold}
                disabled={disabled}
                onChange={(event) => {
                  setThreshold(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="panel-footer">
        <button
          type="button"
          className="btn btn-success btn-sm"
          disabled={disabled}
          onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
        >
          <em className="fa fa-save"></em>
          {isSubmitting ? `${props.submitText}...` : props.submitText}
        </button>
      </div>
    </div>
  );
}
